export enum RoutePath {
  Login = 'login',
  Blog = 'blog',
  HomepageCarousel = 'homepageCarousel',
  HotelOffers = 'hotelOffers',
  FrequentlyAskedQuestion = 'faq',
  Profile = 'profile',
  Error = 'error',
}
